// @ts-nocheck
/**
 * Shim — the hook was promoted to src/customHooks/useColumnWidths.ts (generic).
 * We keep this wrapper passing the Dashboard's original key so we don't
 * invalidate widths already saved in users' browsers.
 */
import { useColumnWidths as useColumnWidthsGeneric } from "../../../customHooks/useColumnWidths";

const STORAGE_KEY = "dashboardColumnWidths.v1";

export const useColumnWidths = () => useColumnWidthsGeneric(STORAGE_KEY);
